"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgAmenityCoveredParking = function SvgAmenityCoveredParking(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M807.1 676.3h-54.2c-6.4 0-9.6-3.2-9.6-9.6-3.2-19.1-22.3-54.2-28.7-70.2-9.6-16-28.7-57.4-89.3-57.4H414.7c-60.6 0-79.8 41.5-89.3 57.4-9.6 16-25.5 51-28.7 70.2 0 6.4-6.4 9.6-9.6 9.6h-57.4c-6.4 0-9.6 3.2-9.6 9.6v28.7c0 6.4 3.2 9.6 9.6 9.6l31.9 3.2c6.4 0 9.6 3.2 9.6 9.6l9.6 229.7c0 6.4 6.4 9.6 9.6 9.6h63.8c6.4 0 16-6.4 16-12.8v-63.8c0-6.4 3.2-9.6 9.6-9.6 44.7 3.2 92.5 6.4 137.2 6.4s92.5-3.2 137.2-6.4c6.4 0 9.6 3.2 9.6 9.6v63.8c0 6.4 9.6 12.8 16 12.8h63.8c6.4 0 9.6-6.4 9.6-9.6l9.6-229.7c0-6.4 3.2-9.6 9.6-9.6l31.9-3.2c6.4 0 9.6-3.2 9.6-9.6v-28.7c2.7-6.4-.4-9.6-6.8-9.6zM373.2 800.7c-25.5 0-41.5-12.8-41.5-31.9s0-38.3 41.5-38.3c44.7 0 54.2 16 54.2 38.3.1 19.1-22.3 31.9-54.2 31.9zm-12.7-121.2s9.6-35.1 19.1-54.2c16-31.9 41.5-31.9 60.6-31.9h156.3c19.1 0 44.7 0 60.6 31.9 9.6 19.1 19.1 54.2 19.1 54.2s-67-3.2-156.3-3.2-159.4 3.2-159.4 3.2zm303 121.2c-28.7 0-54.2-12.8-54.2-31.9s9.6-38.3 54.2-38.3c38.3 0 41.5 16 41.5 38.3-3.2 19.1-16 31.9-41.5 31.9zM1024 953.8c0 16-12.8 25.5-25.5 25.5h-22.3c-16 0-25.5-12.8-25.5-25.5V204.2c0-51-41.5-89.3-89.3-89.3H162.7c-51 0-89.3 41.5-89.3 89.3v749.7c0 16-12.8 25.5-25.5 25.5H25.5c-16 0-25.5-12.8-25.5-25.5V204.2C0 114.8 70.2 44.7 159.5 44.7h701.8c89.3 0 159.5 73.4 159.5 159.5v261.6l3.2 488z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgAmenityCoveredParking, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;